export const LANG_ZH = 'zh';
export const LANGUAGE_ZH = 'zh-CN';
export const LANG_EN = 'en';
export const LANGUAGE_EN = 'en-US';
export const LANGUAGE = [
  { label: '简体中文', value: LANG_ZH, language: LANGUAGE_ZH, icon: 'gt-a-line-Chinese' },
  { label: 'English', value: LANG_EN, language: LANGUAGE_EN, icon: 'gt-line-English1' }
];
/* 存储到storage中的key， 用于多语言 */
export const LANG_KEY = 'gitcode_lang';
